import type { ReactNode } from "react";
import { chromeSelectClass } from "@/lib/map-chrome";

interface MainWorkspaceLayoutProps {
  header: ReactNode;
  sidebar: ReactNode;
  /** Полоска над workspace; если не передана — слот и border не рендерятся. */
  toolbar?: ReactNode;
  workspace: ReactNode;
}

export default function MainWorkspaceLayout({
  header,
  sidebar,
  toolbar,
  workspace,
}: MainWorkspaceLayoutProps) {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {header}
      <div className="flex flex-1 overflow-hidden">
        <div data-onboarding="sidebar-nav" className="flex h-full min-h-0 shrink-0">
          {sidebar}
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          {toolbar != null ? (
            <div
              className={`relative z-[60] flex min-w-0 shrink-0 items-center border-b border-border bg-background ${chromeSelectClass}`}
            >
              {toolbar}
            </div>
          ) : null}
          <div
            data-onboarding="map-canvas"
            className={`relative flex-1 ${chromeSelectClass}`}
          >
            {workspace}
          </div>
        </div>
      </div>
    </div>
  );
}
